
import { useState, useMemo } from 'react';
const getWeekDateRange = () => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sunday
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - dayOfWeek);
  startOfWeek.setHours(0, 0, 0, 0);

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 4); // Thursday
  endOfWeek.setHours(23, 59, 59, 999);


  return { startOfWeek, endOfWeek };
};
export const useReportsFilters = (enabledStages: any[], studentsWithAttendance: any[]) => {
  const { startOfWeek, endOfWeek } = getWeekDateRange();
  const [startDate, setStartDate] = useState<Date | undefined>(startOfWeek);
  const [endDate, setEndDate] = useState<Date | undefined>(endOfWeek);
  const [selectedGrade, setSelectedGrade] = useState("all");
  const [selectedSection, setSelectedSection] = useState("all");
  const [selectedStage, setSelectedStage] = useState("all");
  const [sortType, setSortType] = useState<"most_absent" | "best_attendance">("most_absent");

  // console.log('=== useReportsFilters Debug ===');
  // console.log('startDate:', startDate);
  // console.log('endDate:', endDate);
  // console.log('selectedGrade:', selectedGrade);
  // console.log('selectedSection:', selectedSection);
  // console.log('selectedStage:', selectedStage);
  // console.log('sortType:', sortType);

  // Get filtered available grades


  const filteredAvailableGrades = useMemo(() => {
      const getFilteredAvailableGrades = () => {
    // console.log('=== useReportsFilters - getFilteredAvailableGrades Debug ===');
    // console.log('selectedStage:', selectedStage);
    // console.log('enabledStages:', enabledStages);
    // console.log('studentsWithAttendance count:', studentsWithAttendance.length);
    
    if (selectedStage && selectedStage !== "all") {
      const stage = enabledStages.find(s => s?.id === selectedStage);
      // console.log('Found stage:', stage);
      if (stage && stage.grades) {
        const grades = stage.grades.map((g: { name: any; }) => g?.name || '').filter(name => name);
        // console.log('Grades from stage:', grades);
        return grades;
      }
    }
    // Get all available grades from students
    const studentGrades = [...new Set(studentsWithAttendance.map(s => s?.grade).filter(grade => grade))];
    // console.log('Grades from students:', studentGrades);
    return studentGrades;
  };
    return getFilteredAvailableGrades();
  }, [enabledStages, selectedStage, studentsWithAttendance]);

  // Get available sections for selected grade


  const availableSectionsForGrade = useMemo(() => {
      const getAvailableSectionsForGrade = () => {
    if (!selectedGrade || selectedGrade === "all") return [];
    
    if (selectedStage && selectedStage !== "all") {
      const stage = enabledStages.find(s => s?.id === selectedStage);
      if (stage && stage.grades) {
        const gradeObj = stage.grades.find(g => g?.name === selectedGrade);
        if (gradeObj && gradeObj.sections) {
          return gradeObj.sections.filter(section => section);
        }
      }
    }
    
    // If no sections in stage settings, use student sections
    const sections = [...new Set(
      studentsWithAttendance
        .filter(s => s?.grade === selectedGrade)
        .map(s => s?.section)
        .filter(section => section)
    )];
    
    return sections.length > 0 ? sections : ['أ'];
  };
    return getAvailableSectionsForGrade();
  }, [enabledStages, selectedGrade, selectedStage, studentsWithAttendance]);

  // Reset selections when stage changes
  const handleStageChange = (value: string) => {
    setSelectedStage(value);
    setSelectedGrade("all");
    setSelectedSection("all");
  };

  // Reset section when grade changes
  const handleGradeChange = (value: string) => {
    setSelectedGrade(value);
    setSelectedSection("all");
  };

  // Helper function to get stage display name safely - ALWAYS returns a string
  const getSelectedStageDisplayName = () => {
    if (!selectedStage) return "";
    const stage = enabledStages.find(s => s?.id === selectedStage);
    return stage?.name || "";
  };

  // Helper function to get period display text
  const getPeriodDisplayText = () => {
    if (startDate && endDate) {
      return `من ${startDate.toLocaleDateString('ar-SA')} إلى ${endDate.toLocaleDateString('ar-SA')}`;
    }
    return "جميع الفترات";
  };

  const getPeriodDateRange = () => {
    // Return date range if start date is set (end date is optional)
    if (startDate) {
      return {
        startDate,
        endDate: endDate || startDate // Use start date as end date if end date is not set
      };
    }
    else  {
      return {
        startDate: new Date(),
        endDate: new Date()
      };
    }
    // Return undefined if no start date is set
    return undefined;
  };

  return {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedGrade,
    selectedSection,
    setSelectedSection: (value: string) => setSelectedSection(value),
    selectedStage,
    sortType,
    setSortType,
    filteredAvailableGrades,
    availableSectionsForGrade,
    handleStageChange,
    handleGradeChange,
    getSelectedStageDisplayName,
    getPeriodDisplayText,
    getPeriodDateRange
  };
};
